import { useState, useRef, useCallback } from 'react';

const useSpeechSynthesis = () => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const supported = 'speechSynthesis' in window;
  const utteranceRef = useRef(null);

  const speak = useCallback((text, options = {}) => {
    if (!supported) return;
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.rate = options.rate || 1.0;
    utterance.pitch = options.pitch || 1.0;
    utterance.volume = options.volume || 1.0;
    utterance.lang = options.lang || 'en-US';
    if (options.voice) utterance.voice = options.voice;
    utterance.onstart = () => setIsSpeaking(true);
    utterance.onend = () => {
      setIsSpeaking(false);
      if (options.onend) options.onend();
    };
    utterance.onerror = () => {
      setIsSpeaking(false);
      if (options.onend) options.onend();
    };
    utteranceRef.current = utterance;
    window.speechSynthesis.speak(utterance);
  }, [supported]);

  const cancel = useCallback(() => {
    window.speechSynthesis.cancel();
    setIsSpeaking(false);
  }, []);

  return {
    isSpeaking,
    supported,
    speak,
    cancel,
  };
};

export default useSpeechSynthesis;
